var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.577,
    height: 27.577,
    viewBox: "0 0 27.577 27.577",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dark_mode",
    d: "M12.759,6.845A11.35,11.35,0,0,0,23.683,21.231a11.261,11.261,0,0,0,3.049-.414A10.727,10.727,0,1,1,12.759,6.845ZM16.788,3A13.788,13.788,0,1,0,30.577,16.788a15.507,15.507,0,0,0-.153-2.084A8.28,8.28,0,1,1,18.872,3.153,15.507,15.507,0,0,0,16.788,3Z",
    transform: "translate(-3 -3)",
    fill: "#23262f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/dark_mode.765a5e11deaffdda962529e3fca041a6.svg";
export { ForwardRef as ReactComponent };